// 51585e

export const baseCardStyling = {
  flex: 1,
  minHeight: 0,
  backgroundColor: '#4c4c4dff',
  borderRadius: 3,
  border: '3px solid #5e5e5eff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'yellow',
  fontSize: '3.5rem',
  fontWeight: 'bold',
  padding: 2,
  //   cursor: 'pointer', // Shows it's clickable
  userSelect: 'none', // Prevents text selection
  //   transition: 'all 0.2s ease', // Smooth hover/active
  boxShadow: 3, // Subtle depth
};

export const baseCardButtonStyling = {
  cursor: 'pointer', // Shows it's clickable
  userSelect: 'none', // Prevents text selection
  transition: 'all 0.2s ease', // Smooth hover/active
  // Hover effect
  '&:hover': {
    backgroundColor: '#5a5a5bff',
    borderColor: '#7a7a7aff',
    transform: 'scale(1.02)',
    boxShadow: 6,
  },

  // Active (clicked/pressed) effect
  '&:active': {
    backgroundColor: 'yellow',
    color: '#4c4c4dff',
    transform: 'translateY(0) scale(0.99)',
    boxShadow: 2,
    transition: 'all 0.1s ease',
  },

  // Optional: Focus style for keyboard navigation
  '&:focus-visible': {
    outline: '3px solid #ffff00',
    outlineOffset: 4,
  },
};
